import { FC } from "react"
import ReactQuill from "react-quill"

import { RichTextBlock } from "../types/types"

import "react-quill/dist/quill.snow.css"

type RichTextBlockEditorProps = {
  block: RichTextBlock
  onChange: (patch: Partial<RichTextBlock>) => void
}

const modules = {
  toolbar: [
    [{ header: [1, 2, 3, false] }],
    ["bold", "italic", "underline", "strike"],
    [{ list: "ordered" }, { list: "bullet" }],
    [{ align: [] }],
    ["link"],
    ["clean"]
  ]
}

const formats = ["header", "bold", "italic", "underline", "strike", "list", "bullet", "align", "link"]

export const RichTextBlockEditor: FC<RichTextBlockEditorProps> = ({ block, onChange }) => {
  return (
    <div className="bg-white rounded-md overflow-hidden text-black">
      <ReactQuill
        theme="snow"
        value={block.props.html}
        onChange={(html) =>
          onChange({
            props: {
              ...block.props,
              html
            }
          })
        }
        modules={modules}
        formats={formats}
        style={{
          minHeight: 200
        }}
      />
    </div>
  )
}
